export const BOX_SORT_DROPDOWN_DATA = [
  {
    label: "投稿日が新しい順",
    value: "latest_realization_created_at",
  },
  {
    label: "総ストックが多い順",
    value: "realizations_count",
  },
  {
    label: "ROOTSが多い順",
    value: "roots_count",
  },
  {
    label: "WILLが多い順",
    value: "will_count",
  },
  {
    label: "EXPが多い順",
    value: "exp_count",
  },
  {
    label: "いいねが多い順",
    value: "favorites_count",
  },
  {
    label: "コメントが多い順",
    value: "comments_count",
  },
  {
    label: "平均ストックが多い順",
    value: "avg_realization",
  },
];

export const BOX_TEMPLATE: {
  [key: string]: {
    title: string;
    desc: string;
    text: string;
  };
} = {
  subject_reflection: {
    title: "教科の振り返り",
    desc: "生徒は授業で学んだ内容に関して、興味を持ったことや理解できなかった点を整理し言語化するとともに、授業後に復習や調べ学習など何をするかを具体的に考えさせることで、次の学習の行動を促すことができます。",
    text: "①本日の授業内容\n\n②授業で「学んだこと」や「気づいたこと」、「理解が難しかったこと」を自分の言葉で書きましょう。\n\n③授業を受けて「やってみたい」と思ったことがあれば書き留めておきましょう。（⚪︎⚪︎をもっと調べる／現地に行ってみたい／実験してみる、など自由に）",
  },
  shr_realization_reflection: {
    title: "【日次】振り返り",
    desc: "生徒が自身の取り組みの中で気づいたことや感じたことを振り返り言語化することで、自己内省や自己分析の力を高めることができます。また継続的に振り返りを行うことで、将来的に卒業後の進路やキャリアを考える際の素材となります。",
    text: "一日を振り返って感じたことを、ありのままに自分の言葉で書きましょう。(驚いたこと/楽しいこと/ハッとしたこと/心がざわざわしたこと/ドキドキしたこと…)",
  },
  shr_action_reflection: {
    title: "【週次】行動の振り返り",
    desc: "生徒が自身の取り組みの中で、行動の良かった点や改善点を客観的に振り返ることで、自己表現の力を高めるとともに、目的に向けて主体的/自律的に行動していくことを促します。",
    text: "①この一週間の取り組みにおいて、自分の中で上手くいったこと/上手くいかなかったことなど気づいたことを書きましょう。\n\n②次の一週間で、その取り組みにおいて「こうしてみよう」と思うことを具体的に書きましょう。",
  },
  shr_action_realization_reflection: {
    title: "【週次】気づき/行動の振り返り",
    desc: "生徒が自身の取り組みの中で気づいたことや具体的な行動を振り返ることで、自身の思考と行動を総合的に自己分析しながら主体的な行動を促します。また継続的に振り返りを行うことで、将来的に卒業後の進路やキャリアを考える際の素材となります。",
    text: "①この一週間で「力を入れて取り組んだこと」や「印象に残っていること」を書きましょう。\n\n②その取り組みにおいて、自分の中で上手くいったこと/上手くいかなかったことを書きましょう。また、その時にどんな気持ちだったのか(驚き/楽しい/ハッとした/モヤモヤ…)、思い出してみましょう。\n\n③次の一週間で、その取り組みに対して「意識したいこと」や「具体的に行動したいこと」を書きましょう。",
  },
};

export enum EOrderType {
  DESC = "desc",
  ASC = "asc",
}

export enum EOrderBy {
  LATEST_REALIZATION_CREATED_AT = "latest_realization_created_at",
  REALIZATION_COUNT = "realizations_count",
  ROOTS_COUNT = "roots_count",
  WILL_COUNT = "will_count",
  EXP_COUNT = "exp_count",
  FAVORITE_COUNT = "favorites_count",
  COMMENTS_COUNT = "comments_count",
  AVG_REALIZATION = "avg_realization",
}
